import { getCryptoPro } from '@/libs/crypto_pro/index'
import { DigitalSignatureCurrentStatus } from '@/libs/digital_signature/current_status'
import { EditingUserInformation } from '@/libs/digital_signature/edit_userinfo'
import { $ } from '@/libs/jquery/index'
import { routes } from '@/libs/routes/index'
import { baseSelector } from '@/views/crm/leads/etp_gpb_consulting/shared/edit/form/index.ts'
import { Base64 } from 'js-base64'

interface IRemoveInteractionsOption {
  ucCurrentStatus: DigitalSignatureCurrentStatus
  statusChangehandler(): void
}

export class DigitalSignatureCreation {
  public base: JQuery = null

  public ucCurrentStatus: DigitalSignatureCurrentStatus
  public EditingUserInformation: EditingUserInformation
  public statusChangehandler: () => void
  public leadID: number

  private selectors: ISelectors = {
    base: baseSelector,
    certList: '[data-selector="digitalSignature__select"]',
    certRegisteredButton: '[data-uc-action="privatekey_created"]',
    editUserButton: '[data-uc-action="edit_user"]',
    editedUserInfo: '[data-selector="digitalSignature__editedUserInfo"]',
    popup: '[data-selector="digitalSignature__popup"]',
    signButton: '[data-uc-action="uc_request_not_initialized"]',
  }

  constructor(options: IRemoveInteractionsOption) {
    this.base = $(this.selectors.base)

    if (this.base.length) {
      const { ucCurrentStatus,
        statusChangehandler,
      } = options
      this.ucCurrentStatus = ucCurrentStatus
      this.statusChangehandler = statusChangehandler
      this.EditingUserInformation = new EditingUserInformation()

      this.init()
    }
  }

  public init(): void {
    this.setLeadID()
    this.base
      .on('click', this.selectors.signButton, (e) => this.createUser(e))
      .on('click', this.selectors.certRegisteredButton, (e) => this.createUser(e))
  }

  private createUser(e: JQuery.TriggeredEvent): void {
    const btn = $(e.target)
    btn.attr('disabled', 'disabled')
    this.getUserParams().then((response) => this.createCryptoRequest(response, btn))
  }

  private createCryptoRequest(response, btn: JQuery): void {
    if (response.user_id) {
      window.location.reload()
    } else {
      response.parameters.waitAsyncOperations = 'true'

      getCryptoPro().then((CryptoPro) => {
        const params = {
          certHASH: this.base.find(this.selectors.certList).val(),
          contentEncoding: cadesplugin.CADESCOM_BASE64_TO_BINARY,
          dataToSign: Base64.encode(response.parameters.notSignedRequest),
        }

        CryptoPro
          .call('signData', params.certHASH, params.dataToSign, false).then((result) => {
            params.dataToSign = result

            CryptoPro
              .call('signData', params.certHASH, params.dataToSign, false).then((result2) => {
                response.parameters.rawSignedRegRequest = result2
                params.dataToSign = Base64.encode(JSON.stringify(response.parameters))

                CryptoPro
                  .call('signData', params.certHASH, params.dataToSign, false).then((result3) => {
                    response.signed_parameters = result3

                    const url: string = routes.crm_verification_center_users_path({ lead_id: this.leadID })
                    /* tslint:disable-next-line variable-name */
                    const register_user_data = { request_body: response }

                    if (response.method === 'SubmitAndAcceptRegChangeRequest') {
                      this.EditingUserInformation.setUser(response.parameters.notSignedRequest)
                      this.sendUpdateRequest({url, register_user_data, btn})
                    } else {
                      this.sendCreationRequest({url, register_user_data, btn})
                    }

                    this.ucCurrentStatus.set('Ожидается создание пользователя в УЦ')
                  })
              })
          })
      })
    }
  }

  private sendUpdateRequest({url, register_user_data, btn}): void {
    $
      .ajax({ url, data: register_user_data, method: 'PATCH' })
      .then(() => {
        this.showEditedUser()
        this.showGetCertificate()
        btn.removeAttr('disabled')
      })
      .fail((res) => {
        this.showError(res)
        btn.removeAttr('disabled')
      })
  }

  private showEditedUser(): void {
    this.EditingUserInformation.showIn(this.selectors.editedUserInfo)
  }

  private setLeadID(): void {
    this.leadID = this.base.find(this.selectors.popup).data('lead-id')
  }

  private getUserParams(): JQuery.jqXHR {
    const url = routes.new_crm_verification_center_user_path({ lead_id: this.leadID })

    return $.get(url)
  }

  private sendCreationRequest({url, register_user_data, btn}): void {
    $
      .post(url, register_user_data)
      .then(() => {
        this.showGetCertificate()
        btn.removeAttr('disabled')
      })
      .fail((res) => {
        this.showError(res)
        btn.removeAttr('disabled')
      })
  }

  private showGetCertificate(): void {
    this.ucCurrentStatus.set('Пользователь успешно создан в УЦ. Для создания сертификата нажмите "Отправить в УЦ"')
    this.statusChangehandler()
  }

  private showError(response): void {
    this.ucCurrentStatus.setError('Ошибка создания пользователя в УЦ')
    const errorMessage: string = response.responseJSON.error
    alert(`Ошибка: ${ errorMessage }`)
  }
}
